import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTenant } from "../../context/TenantContext";

import AppLoadingView from "../Common/AppLoadingView";
import LoadingViewIcon from "@mui/icons-material/Fingerprint";

const ProtectedRoute = ({ children, requireTenant = true }) => {
    const auth = useAuth();
    const location = useLocation();
    const { getTenant } = useTenant();

    const [authChecked, setAuthChecked] = useState(false);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                await auth.ensureValidToken();
            } catch (e) {
                // If refresh fails we will redirect to /login below.
                console.warn("Auth token refresh failed", e);
            } finally {
                if (!cancelled) setAuthChecked(true);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [auth]);

    if (!authChecked) {
        return (
            <AppLoadingView
                title="Restoring your session"
                description="Please wait while we verify your session and refresh your access."
                icon={LoadingViewIcon}
            />
        );
    }

    if (!auth.isAuthenticated()) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (requireTenant && !getTenant()) {
        return <Navigate to="/select-tenant" replace />;
    }

    return children;
};

export default ProtectedRoute;